import React, { useContext, useState, useEffect } from "react";
import MainContext from "../../state/main/mainContext";
import { Link } from "react-router-dom";
import {withRouter} from 'react-router-dom'
import ReactGA from 'react-ga';

const Modal8 = ({ history: {push} }) => {
  const mainContext = useContext(MainContext);
  const { setStudentData, formData } = mainContext;
  const moveForward = () => {
    setStudentData(formData)
  };

  useEffect(() => {
    ReactGA.pageview(window.location.pathname); 
  }, [])

  return (
    <section id="modal-8">
      <div className="container">
        <p>
          By confirming your details you understand that this tool is for
          entertainment purposes only. It provides a general estimate of a range
          of possible graduation dates and is based on your input and the
          learning pace of a typical <strong>Learn4Life</strong> student. Every
          student’s situation is different, and <strong>Learn4Life</strong> does
          not make any promises as to when you will complete your credits.
        </p>
        <Link onClick={moveForward} to="/calculating" className="btn btn-green">
          I’m ready to change my story!
        </Link>
      </div>
    </section>
  );
};

export default withRouter(Modal8);
